/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_EXTENT: 'SET_EXTENT',
  MAP_LOADED: 'MAP_LOADED',
  IRWIN_ID_PERIMETER: 'IRWIN_ID_PERIMETER',
  REHYDRATE: 'REHYDRATE'
};
